import { useState, ReactNode } from 'react';
import './News.css';
import { Link, useSearchParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

interface NewsItem {
  id: string;
  date: string;
  content: string | ReactNode; // меняем JSX.Element на ReactNode
  video?: {
    videoId: string;
    videoHash: string;
    facadeImage: string;
    videoTitle: string;
  };
  videoContent?: string | ReactNode; // меняем JSX.Element на ReactNode
  socialLinks?: { platform: string; url: string; icon: string }[];
}

const News: React.FC = () => {
  const [isVideoLoaded, setIsVideoLoaded] = useState<{ [key: string]: boolean }>({});
  const [searchParams, setSearchParams] = useSearchParams();
  const currentPage = parseInt(searchParams.get('page') || '1', 10);
  const itemsPerPage = 10;

  const handleFacadeClick = (newsId: string) => {
    setIsVideoLoaded((prev) => ({ ...prev, [newsId]: true }));
  };

  const newsItems: NewsItem[] = [
    {
      id: '0666',
      date: '▲▲ ▲▲ ▲▲',
      content: (
        <>
          <span className="yellow-underline">
            <a
              href="https://sergey-mavrodi.com/images/news/0042.webp"
              style={{ fontSize: '17px', textDecorationColor: 'rgb(255, 205, 0)' }}
              rel="noopener noreferrer"
            >Стоимость
            </a>
          </span>
          <br/>
          <br/>
          <span className="yellow-underline">
            <a
              href="https://sergey-mavrodi.com/images/news/0033.webp"
              style={{ fontSize: '17px', textDecorationColor: 'rgb(255, 205, 0)' }}
              rel="noopener noreferrer"
            >Статистика
            </a>
          </span>
          <br/>
          <br/>
          <Link to="/news/news12" className="yellow-underline" style={{ fontSize: '17px' }}>
            Творчество Сергея Мавроди
          </Link>
          <br />
          <br />
          <Link to="/news/news4" className="yellow-underline" style={{ fontSize: '17px' }}>
            Идея создания Театра Сергея Мавроди
          </Link>
          <br />
          <br />
          <span className="yellow-underline">
            <a
              href="https://volga-kaspiy.ru/conflict/v-volzhskom-reshili-postavit-syna-lyutsifera-mavrodi.html/"
              style={{ fontSize: '17px', textDecorationColor: 'rgb(255, 205, 0)' }}
              target="_blank"
              rel="noopener noreferrer"
            >В Волжском решили поставить «Сына Люцифера» Мавроди
            </a>
          </span>
          <br/>
          <br/>
          <Link to="/lk/favoriten" className="yellow-underline" style={{ fontSize: '17px' }}>
            <svg width="24" height="24" stroke="rgb(255, 255, 0)"><polygon points="22.000,12.000 16.763,14.750 17.000,20.660 12.000,17.500 7.000,20.660 7.237,14.750 2.000,12.000 7.237,9.250 7.000,3.340 12.000,6.500 17.000,3.340 16.763,9.250" /></svg>
            ИЗБРАННОЕ (только в ЛК)
          </Link>
          
        </>
      ),
    },


   {
      id: '0049',
      date: '17 Июля, 2025',
      content: (
        <p style={{textAlign: 'center'}}>
          <span className="zolt">
            Так, ну что... скоро грянет Юбилей - 70 лет!
            <br />
            В связи с этим - поступило Предложение:
            <br />
            Организовать совместный Подарок.
            <br /><br />
            11.08.2025 с 00:00 по 00:15 (по МСК) 
            <br />
            создаётся общесистемный Канал со Вселенной.
            <br />
            И так будет Всегда - так рождается новая Традиция.
            <br /><br />
            В этот Период пожелайте - что Вы хотите для СПМ
            <br />
            и самое заветное Желание обязательно сбудется.
            <br />
            Даже нарушая все имеющиеся законы Бытия.
            <br /><br />
            Каждый может принять Участие.
            <br />
            И чем больше Нас, тем сильнее Сигнал
            <br />
            и выше Шанс, что Вселенная услышит Нас.
            <br /><br />
            Администратор
          </span>
        </p>
      ),
    },
    {
      id: '0048',
      date: '15 Июля, 2025',
      content: (
        <>
        <p style={{ fontSize: '33px', textAlign: 'center' }}>Демон</p>
        </>
      ),
      video: {
        videoId: '1101247744',
        videoHash: 'a366ada18e',
        facadeImage: '/images/KTL/FG/095.avif',
        videoTitle: 'Демон / Сергей Мавроди',
      },
      
    },
    {
      id: '0047',
      date: '14 Июля, 2025',
      content: (
        <div style={{ textAlign: 'center' }}>
          <Link to="/auslandsamt/post4" className="yellow-underline" style={{ fontSize: '33px' }}>Erzähl mir, dunkler Engel…</Link>
          <br />
          <br />
          <br />
          <p style={{textAlign: 'center'}}>
                Erzähl mir, dunkler Engel, leis,<br />
                Von zerplatzten Träumen – kalt wie Eis,<br />
                über des Schicksals weiße Spur<br />
                achtern nur.<br />
                <br /><br />
                Erzähl mir, wie Menschen betrügen,<br />
                die sie liebenden Augen belügen.<br />
                Welche Farbe hat das Blut<br />
                Der, der trügt.<br />
                <br /><br />
                Geht’s euch gut dort in der Höll’?<br />
                Ich komm rein – ihr habt ’ne Stell’.<br />
                Schau zum Feuer kurz vorbei,<br />
                Bin dabei.<br />
                <br /><br />
                Du eilst? Wiedersehen will ich dich,<br />
                Doch vergiss mich bitte nicht!<br />
                Zu besuchen mich versprich.<br />
                Flieg vorbei!<br />
                </p>
        </div>
      ),
    },
    {
      id: '0046',
      date: '10 Июля, 2025',
      content: (
        <>
        <p style={{ fontSize: '33px', textAlign: 'center', color: 'rgb(255, 0, 255)' }}><em>«42»</em></p>
        </>
      ),
      video: {
        videoId: '1100213627',
        videoHash: '32195b2bd1',
        facadeImage: '/images/news/0046.avif',
        videoTitle: '42 / Сергей Мавроди',
      },

    },
    {
      id: '0045',
      date: '09 Июля, 2025',
      content: (
        <>
          <Link to="/schriftstellerei/gefangnis/zweiundvierzig" className="yellow-underline" style={{ fontSize: '17px' }}>
            42
          </Link>
          <br /><br />
          <p style={{fontWeight: 'normal'}}>
            Абсолютно симметричное число. Два всего таких в тысячелетии. Второе — 22.02.2022. Ровно через 11 лет и 11 дней после первого, кстати.
          </p>
          <Link to="/schriftstellerei/sohnluzifers/tag16" className="yellow-underline" style={{ fontSize: '17px' }}>
            Сын Люцифера — День 16, Форум
          </Link>
          <br /><br />
          <p style={{fontWeight: 'normal'}}>
            А 1260 дней – это как раз ровно все те же 42 месяца. Просто авторы Апокалипсиса, судя по всему, намеренно разделяют всё дьявольское и божественное. Дьявольское меряется в месяцах, а божественное в – днях. Хотя реальный срок всё тот же. Все те же 42 месяца.
          </p>
          <Link to="/schriftstellerei/sohnluzifers/tag139" className="yellow-underline" style={{ fontSize: '17px' }}>
            Сын Люцифера — День 139, Форум — 3
          </Link>
          <br /><br />
          <p style={{fontWeight: 'normal'}}>
            42 месяца, по Апокалипсису опять же, будет править миром Антихрист, зверь из бездны. «И дана ему власть действовать сорок два месяца».
          </p>
          <br />
          <hr />
          <p style={{fontWeight: 'normal', textAlign: 'center'}}><em>
          <strong>22.02.2022 + 1260 дней = 05.08.2025 <br /><br />22.02.2022 + 42 месяца = 22.08.2025</strong><br /><br />
          42 — добро или зло? — пока неясно. <br/>Будущее покажет! Ничего ещё не решено!
          </em></p>
        </>
      ),
    },
    {
      id: '0044',
      date: '08 Июля, 2025',
      content: (
        <>
          <Link to="/news/news44" className="yellow-underline" style={{ fontSize: '33px' }}>
            Так, ну что... <em style={{ color: 'rgb(255, 0, 255)' }}>«нужный момент»</em>
          </Link>
        </>
      ),
    },
    {
      id: '0043',
      date: '07 Июля, 2025',
      content: (
        <>
        <p style={{ fontSize: '33px', textAlign: 'center' }}>Сатана</p>
        </>
      ),
      video: {
        videoId: '1099187020',
        videoHash: '35c4aa0bd0',
        facadeImage: '/images/KTL/FG/102.avif',
        videoTitle: 'Сатана / Сергей Мавроди',
      },
      
    },
    {
      id: '0042',
      date: '04 Июля, 2025',
      content: (
        <>
          <span className="yellow-underline">
            <a
              href="https://sergey-mavrodi.com/images/news/0042.webp"
              style={{ fontSize: '33px', textDecorationColor: 'rgb(255, 205, 0)' }}
              rel="noopener noreferrer"
            >Стоимость
            </a>
          </span><br/><br/>
          <img src="./images/news/042.webp" width="593" height="640" alt="Стоимость" />
          <br />
          <br />
          <p>– Уважаемая Антонина Ивановна! – медленно, с паузами, с расстановками вкрадчиво и нежно проворковал Горбалюк, глядя прямо в глаза своей бывшей начальнице, от всей души наслаждаясь этим мгновеньем и всеми силами стараясь растянуть его, продлить как можно дольше. – Вы женщина деловая,.. (Маленькая пауза) …и, соответственно, предложение у меня к Вам… (Опять маленькая пауза) …тоже чисто деловое. (Пауза.) Ничего личного! (Пауза.) Так вот. (Пауза.) Суть этого предложения такова (Длинная пауза.) Я хочу… (Очень длинная пауза) …трахнуть Вас прямо здесь и прямо сейчас!! (Длинная пауза.) За миллион долларов… В задницу! – после еще одной паузы, последней и заключительной, добавил он, вспомнив слова из песни.</p>
          <br />
          <hr />
          <Link to="/schriftstellerei/sohnluzifers/tag18" className="yellow-underline2">#Деньги</Link>
        </>
      ),
    },
    {
      id: '0041',
      date: '27 Июня, 2025',
      content: (
        <>
          <Link to="/lk/favoriten" className="yellow-underline" style={{ fontSize: '33px' }}>
            <svg width="24" height="24" stroke="rgb(255, 255, 0)"><polygon points="22.000,12.000 16.763,14.750 17.000,20.660 12.000,17.500 7.000,20.660 7.237,14.750 2.000,12.000 7.237,9.250 7.000,3.340 12.000,6.500 17.000,3.340 16.763,9.250" /></svg>
            ИЗБРАННОЕ (только в ЛК)
          </Link>
        </>
      ),
    },
    {
      id: '0040',
      date: '26 Июня, 2025',
      content: (
        <>
        <p style={{ fontSize: '33px', textAlign: 'center' }}>Всё как-то не так…</p>
        </>
      ),
      video: {
        videoId: '1096255953',
        videoHash: '019e39af6f',
        facadeImage: '/images/KTL/FG/075.avif',
        videoTitle: 'Всё как-то не так… / Сергей Мавроди',
      },
      
    },
    {
      id: '0039',
      date: '25 Июня, 2025',
      content: (
        <div style={{ textAlign: 'center' }}>
          <Link to="/auslandsamt/post3" className="yellow-underline" style={{ fontSize: '33px' }}>Sündiger Engel, Engel mein…</Link>
          <br />
          <br />
          <br />
          <p style={{textAlign: 'center'}}>
                Sündiger Engel, Engel mein!<br/>
                Nimm mich mit, ich bin allein.<br/>
                Trag mich heim –<br/>
                Ganz geheim.<br/>
                <br/><br/>
                Überm breiten Fluss, ganz still,<br/>
                wo das Wasser fließt, wie will,<br/>
                ein Liedchen mir sing,<br/>
                Beruhigung bring.<br/>
                <br/><br/>
                Dass der Kummer zurückbliebt,<br/>
                dass es Hoffnung immer gibt,<br/>
                Sünde harmlos sein kann,<br/>
                Ab und an.<br/>
                <br/><br/>
                Dass wir, Bruder, ganz bald landen!<br/>
                Wir die selige Stadt dann fanden,<br/>
                Jeder winkt uns froh und satt –<br/>
                Hölle hat!
                </p>
        </div>
      ),
    },
    {
      id: '0038',
      date: '20 Июня, 2025',
      content: (
        <>
        <p>
          Усиление микроскопической флуктуации, происшедшей в <em style={{ color: 'rgb(255, 0, 255)' }}>«нужный момент»</em>, приводит к преимущественному выбору системой одного пути развития из ряда априори одинаково возможных.
          <br /><br />
          Ладно, положим… – И что? Причем здесь Солнце?
          <br /><br />
          Скоро как раз <em style={{ color: 'rgb(255, 0, 255)' }}>«нужный момент»</em>. – Критическая точка. Точка бифуркации. Когда микроскопическое воздействие может вызвать или не вызвать катастрофу.
          </p>
        </>
      ),
      video: {
        videoId: '1094754142',
        videoHash: '2240fbfefb',
        facadeImage: '/images/KTL/FG/062.avif',
        videoTitle: 'На перепутье жизненных дорог… / Сергей Мавроди',
      },
      videoContent: 'На перепутье жизненных дорог…',
      
    },
    {
      id: '0037',
      date: '19 Июня, 2025',
      content: (
        <>
          <p>
            Система, эволюционируя, достигает точки бифуркации, детерминистическое описание становится непригодным. Флуктуация вынуждает систему выбрать ту ветвь, по которой будет происходить дальнейшая эволюция системы. Переход через бифуркацию – такой же случайный процесс, как бросание монеты.
          </p>
          <Link to="/schriftstellerei/sohnluzifers/tag19" className="yellow-underline" style={{ fontSize: '33px' }}>
            Сын Люцифера — День 19, Гений
          </Link>
          <br /><br />
          <p>
            Точки бифуркации – это критические точки. Когда сколь угодно малое воздействие может привести к принципиально новому поведению всей системы. В частности, к катастрофе. Цистерна с капающей сверху водой, стоящая на наклонной платформе. Последняя капля опрокидывает цистерну. Бабочка, пролетевшая на границе области зарождения тайфуна и вызвавшая смерч где-нибудь в Калифорнии.
          </p>
          <br />
          <hr />
          <p style={{fontWeight: 'normal'}}><em>
          Что ж, теперь ясно, почему. Развитие, прогресс неизбежно сопровождаются ростом населения, а значит, и ростом смертности, ростом интенсивности потока излучения смерти. Которое инициирует всё большую активность ближайшего светила, ближайшей звезды, местного Солнца. В конечном итоге на Солнце происходит гигантская вспышка, которая полностью стерилизует планету. Конец. Апокалипсис. Цивилизация гибнет, и всё начинается сначала. «И увидел я новое небо и новую землю, ибо прежнее небо и прежняя земля миновали, и моря уже нет». Да, моря действительно уже не будет. Моря и океаны испарятся практически мгновенно.          
          <br /><br />
          Причем, поскольку цивилизация в этот момент еще недостаточно развита, чтобы как-то защищаться от подобного рода катаклизмов, то механизм этот имеет поистине универсальный характер и действует безотказно. Бороться с ним невозможно в принципе.
          </em></p>
        </>
      ),
    },
    {
      id: '0036',
      date: ' ',
      content: (
        <>
          <p>
          На изображении как будто бы отчётливо видна "птица" или "летательный аппарат" с тянущимся за ним "пламенным следом". Размер крыла "птицы" около 150 тысяч км. Высота "полёта" над поверхностью Солнца — около 2 миллионов км. Размер "птицы", если считать, что это физический, а не оптический объект, более чем в 10 раз превосходит размер Земли.
          </p>
          <span className="yellow-underline">
            <a
              href="https://xras.ru/project_diary.html?post_id=2911"
              style={{ fontSize: '33px', textDecorationColor: 'rgb(255, 205, 0)' }}
              target="_blank"
              rel="noopener noreferrer"
            >Птица над Солнцем
            </a>
          </span>
          <br />
          <br />
          <p>«И говорит мне ангел: “Птица эта − хранитель вселенной. Летит она вместе с Солнцем и, раскинув крылья, принимает на себя лучи его, которые подобны языкам пламени.<br />
          И если бы она не принимала их, не уцелел бы род человеческий, и вообще ничто живое”.<br />
          И сказал я: “Господин, как имя её?”<br />
          И сказал мне ангел: “Феникс имя её”».<br />
          <em>Апокриф. Апокалипсис, Откровение Варуха : 6</em></p>
          <br />
          <hr />
          <p style={{fontWeight: 'normal'}}>
          &#10034; <em>Мавроди вдруг вспомнилась Библия. «И ввергнут их в печь огненную…» «В печь огненную…» В ад! «Печь огненную». Может, Солнце – это и есть ад? «Печь огненная»? А излучение смерти – это просто грешные души, которые туда после смерти отправляются? Попадают. При особенно больших партиях, поступлениях, в аду происходят какие-то процессы, ад, образно говоря, торжествует – и это отражается на Земле. Ну, в общем, люди это чувствуют, становятся нервные, возбудимые, что, в свою очередь, ведет к новым социальным конфликтам, войнам, революциям, к новым жертвам, новым грешным душам и, соответственно, к новому торжеству ада.
          <br /><br />
          Мавроди усмехнулся про себя. Хм!.. Библия библией, но теперь, по крайней мере, ясно, почему не существует сверхцивилизаций. Основной парадокс то ли космологии, то ли ксенологии! Что такое «ксенология»?.. А!.. не важно! да какая разница?! Не о том я думаю. А о чем я думал?.. А, ну да, о сверхцивилизациях. Черт!! Каким-то я рассеянным становлюсь!.. Да, так что там со сверхцивилизациями? Сверхцивилизации… Сверхцивилизации… А!! Почему не существует сверхцивилизаций!? Если космос практически бесконечен, то в нем должно существовать бесчисленное множество сверхцивилизаций, опередивших нас на миллионы лет развития, которые должны были нас уже давным-давно обнаружить. Ну, или, во всяком случае, мы должны были наблюдать следы их деятельности. Однако на практике, как известно, ничего подобного не происходит. Такое впечатление, что никаких сверхцивилизаций не существует вообще. Почему?
          </em></p>
        </>
      ),
    },
    {
      id: '0035',
      date: ' ',
      content: (
        <>
          <p>
          В результате репрессий убито, по различным оценкам, от 1 до 3 миллионов человек, — точное число назвать невозможно в связи с отсутствием переписей; по отношению числа уничтоженных к общему количеству населения режим «красных кхмеров» — один из самых жестоких режимов в истории человечества.
          </p>
          <span className="yellow-underline">
            <a
              href="https://ru.wikipedia.org/wiki/%D0%9A%D1%80%D0%B0%D1%81%D0%BD%D1%8B%D0%B5_%D0%BA%D1%85%D0%BC%D0%B5%D1%80%D1%8B"
              style={{ fontSize: '33px', textDecorationColor: 'rgb(255, 205, 0)' }}
              target="_blank"
              rel="noopener noreferrer"
            >Красные кхмеры
            </a>
          </span>
          <br />
          <br />
          <p>
            &bull; мотыгами, палками, железными прутьями они били своих жертв по голове; ножами и острыми листьями сахарной пальмы они перерезали своим жертвам горло, вспарывали животы, извлекали печень, которую съедали, и желчные пузыри, которые шли на изготовление «лекарств»;<br />
            &bull; используя бульдозеры, они давили людей, а также применяли взрывчатку — чтобы убивать как можно больше за раз;<br />
            &bull; они закапывали людей заживо и сжигали тех, кого подозревали в причастности к оппозиции режиму; они постепенно срезали с них кожу и плоть, обрекая людей на медленную смерть;<br />
            &bull; они подбрасывали детей в воздух, а потом подхватывали их штыками, они отрывали у них конечности, разбивали им головы о деревья;<br />
          </p>
          <br />
          <hr />
          <p style={{fontWeight: 'normal'}}>
          &#10034; <em>Мавроди быстро включил комп и вошел в Сеть. Ага… Ага… Какие у нас там подходящие события за последние годы были?.. А, ну вот, Кампучия, например… полпотовцы, красные кхмеры. Так… нашли… «Казнены свыше миллиона человек…» В каком году это было?.. Так… А с Солнцем что тогда происходило? А?.. Где это у нас?.. А, ну здесь, наверное… Да, точно. Так… смотрим… смотрим… Есть! Всё точно. Разница один год. Как положено. Как доктор прописал. Ну, дела-а!.. Вот тебе и… Мать моя женщина! Да я правда гений. В натуре. Сто пудов!
          <br /><br />
          Он смог догадаться о возможности наличия обратной связи. Допустить ее, саму эту возможность. Предположить, что, быть может, не только солнечная активность стимулирует активность человеческую, но и, наоборот, активность человеческая тоже стимулирует активность солнечную. Появление на Солнце пятен и пр. А почему бы и нет? Социальные катастрофы, гибель людей… Возможно, при смерти людей выделяется какое-то излучение, энергия, которая инициирует процессы на Солнце. А те, в свою очередь, еще больше усиливают активность социальную. А значит, новые жертвы, новые выбросы, порции излучения смерти – новые всплески солнечной активности. И т.д. Змея кусает себя за хвост! Классический процесс с обратной связью. Как, скажем, при спекулятивном росте цен на фондовом рынке. На те же акции. Рост цен стимулирует спрос, а тот в свою очередь, стимулирует новый виток роста цен.        
          </em></p>
        </>
      ),
    },
    {
      id: '0034',
      date: ' ',
      content: (
        <>
          <p>
          В своей книге Чижевский проанализировал большой исторический материал и обнаружил корреляцию максимумов солнечной активности и массовых катаклизмов на Земле.
          </p>
          <span className="yellow-underline">
            <a
              href="https://ru.wikipedia.org/wiki/%D0%97%D0%B5%D0%BC%D0%BD%D0%BE%D0%B5_%D1%8D%D1%85%D0%BE_%D1%81%D0%BE%D0%BB%D0%BD%D0%B5%D1%87%D0%BD%D1%8B%D1%85_%D0%B1%D1%83%D1%80%D1%8C"
              style={{ fontSize: '33px', textDecorationColor: 'rgb(255, 205, 0)' }}
              target="_blank"
              rel="noopener noreferrer"
            >ЧИЖЕВСКИЙ
            </a>
          </span>
          <br />
          <br />
          <p>
          Чижевский установил, что в период повышенной солнечной активности (большого количества пятен на Солнце) на Земле происходят войны, революции, стихийные бедствия, катастрофы, эпидемии, увеличивается интенсивность роста бактерий. 
          </p>
          <br />
          <hr />
          <p style={{fontWeight: 'normal'}}>
          &#10034; <em>Мавроди на глаза попался том Чижевского. Сколько лет валялся на полке, Мавроди в него даже и не заглядывал никогда, а тут вдруг заинтересовался. Как будто под руку кто толкнул. Бес. Он открыл книгу, полистал…
          <br /><br />
          Собственно, теорию Чижевского о наличии четкой взаимосвязи, корреляции между пиками солнечной и человеческой, социальной активности он знал и раньше. Автор, конечно, совершенно гигантскую работу проделал. Удивительную! Таблицы, графики, статистический материал огромный… Всё это, конечно, впечатляло. Но всё это Мавроди уже видел и раньше. Он небрежно просматривал таблицы, мельком сравнивал графики. Да!.. Очень интересно… Несомненная корреляция! Несомненная!.. Четко выраженная взаимосвязь. А впрочем, чему тут удивляться? Солнце – наше светило, ближайшая звезда – естественно, все процессы, там происходящие, и на земную жизнь влияют. И на человека в том числе. К примеру, на его психику, настроение, на его мозговую деятельность. Естественно, взаимосвязь. Чего тут странного? Было бы, скорее, удивительно, если бы этой взаимосвязи не существовало! А так… – это нормально.
          <br /><br />
          Эй! Постойте, постойте-ка!.. А это еще что такое? Почему этот график?.. Ну-ка, ну-ка?.. и этот тоже… Что за черт? Что это значит?
          <br /><br />
          «… Хотя сам факт наличия корреляции был очевиден и никаких сомнений не вызывал, тем не менее в ряде случаев оказывалось, что графики смещены относительно друг друга “не в ту сторону”, что пик активности человеческой деятельности несколько опережал соответствующий пик солнечной активности. Обычно на год-два. Что по логике вещей было абсолютно невозможно. Поскольку получалось, что следствие таким образом предшествует причине. Этот удивительный факт Чижевский объяснить так и не смог…»
          </em></p>
        </>
      ),
    },
    {
      id: '0033',
      date: '11 Июня, 2025',
      content: (
        <>
          <span className="yellow-underline">
            <a
              href="https://sergey-mavrodi.com/images/news/0033.webp"
              style={{ fontSize: '33px', textDecorationColor: 'rgb(255, 205, 0)' }}
              rel="noopener noreferrer"
            >Статистика
            </a>
          </span><br/><br/>
          <img src="./images/news/0333.webp" width="593" height="334" alt="Статистика" />
          <br />
          <br />
          <p style={{textAlign: 'center'}}>Да, я рискнул – и проиграл.<br />
          Ликуйте, ну же!<br />
          Но вечно имя: Ганнибал<br />
          Внушает ужас.</p>
          <p style={{textAlign: 'center'}}>Пусть возродится снова Рим,<br />
          Залижет раны.<br />
          И завоюет целый мир –<br />
          Но были Канны!</p>
          <p style={{textAlign: 'center'}}>Пусть покоряет города,<br />
          Моря и страны.<br />
          Пусть побеждает всех и вся!<br />
          Но – были – Канны.</p>
          <br />
          <hr />
          <Link to="/schriftstellerei/gedichte/gedicht107" className="yellow-underline2">#Ганнибал</Link>
        </>
      ),
    },
    {
      id: '0032',
      date: '03 Июня, 2025',
      content: (
        <>
          <p>
          Модель проста. Собственность страны − собственность её граждан! Эту собственность трудом своим и создавших. Всех! А не кучки избранных. Вот базовая идея. 
          </p>
          <Link to="/schriftstellerei/gefangnis/gazprom" className="yellow-underline" style={{ fontSize: '33px' }}>
            ГАЗПРОМ
          </Link>
          <br />
          <br />
          <p>
          А после этого я перейду ко второй части своей программы. На обломках старого, будем строить, так сказать, новое. Про вторую часть замысла говорить пока не буду.
          </p>
          <br />
          <hr />
          <p>
          Публичное акционерное общество «Газпром» — российская транснациональная энергетическая компания, более 50 % (контрольный пакет) акций которой принадлежит государству. 
          (В ходе рыночных реформ часть акций «Газпрома» была «продана» за приватизационные ваучеры.) - <em>Википедия.</em>
          </p>
        </>
      ),
    },
    {
      id: '0031',
      date: '24 Мая, 2025',
      content: (
        <>
          <p>Энтузиаст (0*2*4*0*8*) из ТСМ попросил о Помощи у нашей Системы для исполнения ранее <a
              href="https://volga-kaspiy.ru/conflict/v-volzhskom-reshili-postavit-syna-lyutsifera-mavrodi.html/"
              style={{ textDecorationColor: 'rgb(0, 0, 0)' }}
              target="_blank"
              rel="noopener noreferrer"
            >
              Заявленного
            </a>.<br /> 
            Система незамедлительно Откликнулась и совершила безвозмездный Перевод на запрашиваемую Сумму.<br />
            Пусть всё Сбудется - Мы Можем Многое!
          </p>
          <hr />
          <img src="./images/news/555.webp" height="593" width="365" alt="Перевод из Газпрома" />
          <img src="./images/news/5.webp" height="406" width="593" alt="Перевод из Системы" />
        </>
      ),
    },
    {
      id: '0030',
      date: '22 Мая, 2025',
      content: (
        <>
          <p>Буду тексты писать идеологические. И выкладывать периодически. :-))</p>
          <Link to="/ideology" className="yellow-underline" style={{ fontSize: '33px' }}>
            ИДЕОЛОГИЯ
          </Link>
          <br />
          <br />
          <p>
          Нет у меня никаких учеников. И слава богу. Только «учеников» мне ещё и не хватало! «Соучастие». Статья УК. Голимая. Для информации. Вам. А общий бизнес я вообще никогда не вёл. Ни с кем. Кстати, по МММ я ведь один проходил. Уникальный случай! Поскольку даже за бухгалтера сам везде расписывался. Чтобы никого не подставлять. Так что… <em>«Дальше всех уходит тот, кто в путь идёт один».</em> Так, кажется? Не помню только, чьё это стихотворение?.. Но не важно. Да. Таким вот образом.
          </p>
          <br />
          <hr />          
          <Link to="/auslandsamt/post2" className="yellow-underline2">
            Английский вариант</Link>
          <br />
          <Link to="/ideology/kodex" className="yellow-underline2">
            КОДЕКС МММ-щика</Link>
          <br />
          <Link to="/schriftstellerei/lieder/lied40" className="yellow-underline2">
            Гимн МММ (Памяти активиста Системы Андрея Ким)</Link>
        </>
      ),
    },
    {
      id: '0029',
      date: '21 Мая, 2025',
      content: (
        <p>          
            В связи с активной Регистрацией новых Пользователей - нам Временно ограничили некоторые функции системных Почтовых ящиков.<br/><br />
            По этой Причине - наблюдаются технические Проблемы при использовании Личных Кабинетов.<br /><br />
            Принимаются все необходимы Меры - Начальство в курсе текущей Ситуации.
            <br /><br />
            Администратор          
          <hr />
          <br />
          <span>22 Мая, 2025 <br /><br />
            Восстановлены все функции системных Почтовых ящиков.<br /><br />
            Решены все технические Проблемы в ЛК.<br /><br />
            Сигнал был услышан!<br /><br />
            Администратор
          </span>
        </p>
      ),
    },
    {
      id: '0028',
      date: '20 Мая, 2025',
      content: (
        <>
          <Link to="/lk" className="yellow-underline" style={{ fontSize: '33px' }}>
            Познайте свою Удачу (только в ЛК)
          </Link>
        </>
      ),
    },
    {
      id: '0027',
      date: '08 Мая, 2025',
      content: (
        <>
          <p>Называйте меня теперь так.</p>
          <Link to="/privacy" className="yellow-underline" style={{ fontSize: '33px' }}>
            ФЕНИКС
          </Link>
          <br />
          <br />
          <p>
          Канал общения со Вселенной открыт!!
          </p>
          <br />
          <hr />
          <p style={{textAlign: 'left'}}>«И говорит мне ангел: “Птица эта − хранитель вселенной. Летит она вместе с Солнцем и, раскинув крылья, принимает на себя лучи его, которые подобны языкам пламени.
          И если бы она не принимала их, не уцелел бы род человеческий, и вообще ничто живое”.<br />
          И сказал я: “Господин, как имя её?”<br />
          И сказал мне ангел: “Феникс имя её”».<br />
          <em>Апокриф. Апокалипсис, Откровение Варуха : 6</em></p>
        </>
      ),
    },
    {
      id: '0026',
      date: '01 Мая, 2025',
      content: (
        <>
          <p>Обновлённый раздел.</p>
          <Link to="/contacts" className="yellow-underline" style={{ fontSize: '33px' }}>
            КОНТАКТЫ
          </Link>
          <br />
          <br />
          <p>
          Руководитель не должен заниматься текучкой. Он вообще не должен ничем заниматься! Он должен отдыхать, ловить рыбу и обдумывать стратегические задачи. Если его присутствие необходимо в офисе − значит, дело плохо организовано.
          </p>
          <br />
          <hr />
        <p>P.S. И имейте в виду. Всё предварительно читает Администратор. Просто честно предупреждаю. Во избежание. :-))</p>
        </>
      ),
    },
    {
      id: '0025',
      date: '24 Апреля, 2025',
      content: (
        <>
          <p style={{ fontSize: '33px', textAlign: 'center' }}>МАРГАРИТА (13.09.2024)</p>
        </>
      ),
      video: {
        videoId: '1077519327',
        videoHash: 'fb268dbce7',
        facadeImage: '/images/KTL/FG/151.avif',
        videoTitle: 'МАРГАРИТА / Сергей Мавроди',
      },
      videoContent: 'Завершено обновление раздела KinoTheater.',
      socialLinks: [
        { platform: 'VK', url: 'https://vk.com/theatermavrodi', icon: '/images/v1.webp' },
        { platform: 'Facebook', url: 'https://www.facebook.com/profile.php?id=100056900434020', icon: '/images/f2.webp' },
        { platform: 'YouTube', url: 'https://www.youtube.com/channel/UCxq5hrk1N1pZ8_Xmkv4xKLg', icon: '/images/y3.webp' },
        { platform: 'RuTube', url: 'https://rutube.ru/channel/39271788/', icon: '/images/r4.webp' },
      ],
    },
    {
      id: '0024',
      date: '20 Апреля, 2025',
      content: (
        <>
          <p style={{ fontSize: '33px', textAlign: 'center' }}>ЕСТЬ ЛЮДИ - ИЗ МЕДИ... (30.07.2024)</p>
        </>
      ),
      video: {
        videoId: '1076876105',
        videoHash: '2a2b467ac5',
        facadeImage: '/images/KTL/FG/276.avif',
        videoTitle: 'ЕСТЬ ЛЮДИ - ИЗ МЕДИ... / Сергей Мавроди',
      },
      videoContent: '– Господи! Вам всё кажется, что самое интересное в этой жизни − зарабатывать деньги. Уверяю вас, это не так. Повторяю, сейчас мне интересно заниматься творчеством. Меня это полностью занимает. Надеюсь, так оно будет и впредь. По крайней мере, в ближайшие сто лет. Если совсем уж край с деньгами наступит и жрать будет нечего − ну, придётся тогда «подзаработать», конечно. Но − не хотелось бы. Вот ей-богу! Надеюсь, до этого дело всё же не дойдёт. Твёрдо уповаю. Ибо мало − я не умею зарабатывать, а много − к катаклизмам всё время вселенским почему-то приводит. Совершенно немыслимым, причём. Каким-то волшебным образом так всё всегда оборачивается. Потом выпутываться ещё приходится. Тьфу, короче!',
      socialLinks: [
        { platform: 'VK', url: 'https://vk.com/theatermavrodi', icon: '/images/v1.webp' },
        { platform: 'Facebook', url: 'https://www.facebook.com/profile.php?id=100056900434020', icon: '/images/f2.webp' },
        { platform: 'YouTube', url: 'https://www.youtube.com/channel/UCxq5hrk1N1pZ8_Xmkv4xKLg', icon: '/images/y3.webp' },
        { platform: 'RuTube', url: 'https://rutube.ru/channel/39271788/', icon: '/images/r4.webp' },
      ],
    },
    {
      id: '0023',
      date: '12 Апреля, 2025',
      content: (
        <>
          <p style={{ fontSize: '33px', textAlign: 'center' }}>АНГЕЛ</p>
        </>
      ),
      video: {
        videoId: '1072614166',
        videoHash: 'c23010f077',
        facadeImage: '/images/KTL/FG/002.avif',
        videoTitle: 'АНГЕЛ / Сергей Мавроди',
      },
      videoContent: 'Первый мультипликационный Фильм на стихи Сергея Мавроди. (18.04.2023)',
      socialLinks: [
        { platform: 'VK', url: 'https://vk.com/theatermavrodi', icon: '/images/v1.webp' },
        { platform: 'Facebook', url: 'https://www.facebook.com/profile.php?id=100056900434020', icon: '/images/f2.webp' },
        { platform: 'YouTube', url: 'https://www.youtube.com/channel/UCxq5hrk1N1pZ8_Xmkv4xKLg', icon: '/images/y3.webp' },
        { platform: 'RuTube', url: 'https://rutube.ru/channel/39271788/', icon: '/images/r4.webp' },
      ],
    },
    {
      id: '0022',
      date: '01 Апреля, 2025',
      content: (
        <>
          <p>Иностранный отдел</p>
          <Link to="/auslandsamt" className="yellow-underline" style={{ fontSize: '33px' }}>
            AUSLANDSAMT
          </Link>
          <br />
          <br />
          <p>
            Патриот ли я? А что это вообще такое? Патриотизм? Вот раньше был СССР. Вы, как патриот, обязаны были любить и Украину, и Грузию… и Латвию, и Эстонию… А теперь вы, как патриот, что их обязаны? Ненавидеть? А завтра они, скажем, опять к нам присоединятся. (Ну, вдруг!) И вы их опять сразу же полюбите? Как-то всё это странно. И подозрительно. Когда люди (патриоты) с такой лёгкостью неимоверной свои убежденья и любови меняют. Как перчатки.
          </p>
          <br />
          <hr />
          <Link to="/auslandsamt/post1" className="yellow-underline2">
            Сын Люцифера — День 1, Игра (Deutsch)
          </Link>
        </>
      ),
    },
    {
      id: '0021',
      date: '26 Марта, 2025',
      content: (
        <>
          <p>Этап — 6. Сделка между ТСМ и КТL. (01.06.2021)</p>
          <Link to="/kinotheater/sohnluzifers/ktltag1" className="yellow-underline" style={{ fontSize: '33px' }}>
            Сын Люцифера — День 1, Игра
          </Link>
          <br />
          <br />
          <p>
            В городе Анапа готовился Гастрольный показ Спектакля "Игра".
            <br />
            <br />
            Между уполномоченными Представителями заключён Уговор:
            <br />
            КТL - осуществляет финансирование ТСМ крупной Суммой.
            <br />
            КТL - получает 33% чистой Прибыли от деятельности ТСМ.
            <br />
            <br />
            P.S. Сделка была "подписана" деловым Рукопожатием.
            <br />
            <br />
            P.P.S. Приказ №333 от 30.01.24 - выполнен. Сделка признана Аннулированной.
          </p>
        </>
      ),
      socialLinks: [
        { platform: 'VK', url: 'https://vk.com/theatermavrodi', icon: '/images/v1.webp' },
        { platform: 'Facebook', url: 'https://www.facebook.com/profile.php?id=100056900434020', icon: '/images/f2.webp' },
        { platform: 'YouTube', url: 'https://www.youtube.com/channel/UCxq5hrk1N1pZ8_Xmkv4xKLg', icon: '/images/y3.webp' },
        { platform: 'RuTube', url: 'https://rutube.ru/channel/39271788/', icon: '/images/r4.webp' },
      ],
    },
    {
      id: '0020',
      date: '22 Марта, 2025',
      content: (
        <>
          <p>Этап — 5. Самодеятельность КиноТеатра LUZIFER. (20.12.2020)</p>
          <Link to="/kinotheater/sohnluzifers/ktltag83" className="yellow-underline" style={{ fontSize: '33px' }}>
            Сын Люцифера — День 83, Писатель
          </Link>
          <br />
          <br />
          <Link to="/kinotheater/sohnluzifers/ktltag37" className="yellow-underline" style={{ fontSize: '33px' }}>
            Сын Люцифера — День 37, Подарок
          </Link>
          <br />
          <br />
          <Link to="/kinotheater/sohnluzifers/ktltag38" className="yellow-underline" style={{ fontSize: '33px' }}>
            Сын Люцифера — День 38, Шантаж
          </Link>
          <br />
          <br />
          <p>
            КиноТеатр - организовал полный Выпуск трёх Экранизаций (Самостоятельно и без какой-либо Помощи), в том числе профинансировал все Направления (режиссёрское, рекламное, юридическое и другие).
            <br />
            <br />
            P.S. Для показа Фильмов и Спектаклей создано Юридическое лицо.
          </p>
        </>
      ),
      socialLinks: [
        { platform: 'VK', url: 'https://vk.com/theatermavrodi', icon: '/images/v1.webp' },
        { platform: 'Facebook', url: 'https://www.facebook.com/profile.php?id=100056900434020', icon: '/images/f2.webp' },
        { platform: 'YouTube', url: 'https://www.youtube.com/channel/UCxq5hrk1N1pZ8_Xmkv4xKLg', icon: '/images/y3.webp' },
        { platform: 'RuTube', url: 'https://rutube.ru/channel/39271788/', icon: '/images/r4.webp' },
      ],
    },
    {
      id: '0019',
      date: '17 Марта, 2025',
      content: (
        <>
          <p>Этап — 4. Корона и КиноТеатр LUZIFER. (09.05.2020)</p>
          <Link to="/kinotheater/sohnluzifers/ktltag9" className="yellow-underline" style={{ fontSize: '33px' }}>
            Сын Люцифера — День 9, Интервью
          </Link>
          <br />
          <br />
          <p>
            КиноТеатр - на должность Режиссёра профинансировал и провёл{' '}
            <Link to="/news/news19" className="yellow-underline1">
              КАСТИНГ.
            </Link>
            <br />
            <br />
            В следствие этого, Энтузиасты Творчества Сергея Мавроди совместно с Режиссёром и КиноТеатром - создали уникальную Экранизацию.
            <br />
            <br />
            КиноТеатр - организовал и оплатил рекламную Компанию для премьерного Показа онлайн Спектакля в условиях Пандемии.
            <br />
            <br />
            P.S. Этот творческий Союз ознаменовал появление Театра Сергея Мавроди.
            <Link to="/news/news4" className="yellow-underline2">
              (Идея создания Театра Сергея Мавроди)
            </Link>
          </p>
        </>
      ),
      socialLinks: [
        { platform: 'VK', url: 'https://vk.com/theatermavrodi', icon: '/images/v1.webp' },
        { platform: 'Facebook', url: 'https://www.facebook.com/profile.php?id=100056900434020', icon: '/images/f2.webp' },
        { platform: 'YouTube', url: 'https://www.youtube.com/channel/UCxq5hrk1N1pZ8_Xmkv4xKLg', icon: '/images/y3.webp' },
        { platform: 'RuTube', url: 'https://rutube.ru/channel/39271788/', icon: '/images/r4.webp' },
      ],
    },
    {
      id: '0018',
      date: '10 Марта, 2025',
      content: (
        <>
          <p>Чтобы побеждать, надо уметь − и отступать.</p>
          <img src="./images/news/0018.webp" width="593" height="174" alt="Масштаб личности Сергея Мавроди" />
          <br />
          <br />
          <p>Масштаб личности определяется лишь масштабом её деяний.</p>
          <br />
          <hr />
          <p>
            С 2007 по 2017 год Хамовнический суд вынес более 200 исполнительных листов в отношении Мавроди: общая сумма его долга составила 1,6 миллиарда рублей. Из них 219 тысяч рублей — долг по госпошлинам, а более 252 миллионов рублей — взыскания имущественного характера в пользу физических и юридических лиц.
          </p>
        </>
      ),
    },
    {
      id: '0017',
      date: '08 Марта, 2025',
      content: (
        <>
          <p>Этап — 3. Первая "неудача" КиноТеатра LUZIFER. (20.05.2018)</p>
          <span className="yellow-underline">
            <a
              href="https://volga-kaspiy.ru/conflict/v-volzhskom-reshili-postavit-syna-lyutsifera-mavrodi.html/"
              style={{ fontSize: '21px', textDecorationColor: 'rgb(255, 205, 0)' }}
              target="_blank"
              rel="noopener noreferrer"
            >
              В Волжском решили поставить «Сына Люцифера» Мавроди
            </a>
          </span>
          <br />
          <br />
          <p>
            КиноТеатр совместно с Энтузиастами Творчества Сергея Мавроди - предпринял "попытку" осуществления Спектакля "Игра" на Сцене города Волжский.
            <br />
            <br />
            P.S. КиноТеатр - возместил затраченные Финансовые средства на Организацию.
          </p>
        </>
      ),
      socialLinks: [
        { platform: 'VK', url: 'https://vk.com/theatermavrodi', icon: '/images/v1.webp' },
        { platform: 'Facebook', url: 'https://www.facebook.com/profile.php?id=100056900434020', icon: '/images/f2.webp' },
        { platform: 'YouTube', url: 'https://www.youtube.com/channel/UCxq5hrk1N1pZ8_Xmkv4xKLg', icon: '/images/y3.webp' },
        { platform: 'RuTube', url: 'https://rutube.ru/channel/39271788/', icon: '/images/r4.webp' },
      ],
    },
    {
      id: '0016',
      date: '03 Марта, 2025',
      content: (
        <>
          <p>Этап — 2. Явление и Первый шаг КиноТеатра LUZIFER. (10.02.2018)</p>
          <Link to="/kinotheater/sohnluzifers" className="yellow-underline" style={{ fontSize: '33px' }}>
            Сын Люцифера (экранизация)
          </Link>
          <br />
          <br />
          <p>
            КиноТеатр - организовал и Полностью профинансировал Выпуск первого АудиоСпектакля в ВидеоФормате.
            <br />
            КиноТеатр - организовал и Полностью профинансировал Выпуск первой Экранизации.
            <br />
            Представители КиноТеатра - приняли личное участие в Съёмках.
            <br />
            <br />
            P.S. Создано при Участии - Энтузиастов Творчества Сергея Мавроди.
          </p>
        </>
      ),
      socialLinks: [
        { platform: 'VK', url: 'https://vk.com/theatermavrodi', icon: '/images/v1.webp' },
        { platform: 'Facebook', url: 'https://www.facebook.com/profile.php?id=100056900434020', icon: '/images/f2.webp' },
        { platform: 'YouTube', url: 'https://www.youtube.com/channel/UCxq5hrk1N1pZ8_Xmkv4xKLg', icon: '/images/y3.webp' },
        { platform: 'RuTube', url: 'https://rutube.ru/channel/39271788/', icon: '/images/r4.webp' },
      ],
    },
    {
      id: '0015',
      date: '01 Марта, 2025',
      content: (
        <>
          <p>Этап — 1. Зарождение КиноТеатра LUZIFER. (05.09.2015)</p>
          <Link to="/kinotheater/zombi" className="yellow-underline" style={{ fontSize: '33px' }}>
            ZОМБИ
          </Link>
          <br />
          <br />
          <p>
            КиноТеатр - осуществил Хорошую финансовую Помощь на развитие Сериала.
            <br />
            КиноТеатр - организовал Локацию для первой Серии в городе Волжский.
            <br />
            Представитель КиноТеатра - принял личное участие в Съёмках.
          </p>
        </>
      ),
      socialLinks: [
        { platform: 'VK', url: 'https://vk.com/theatermavrodi', icon: '/images/v1.webp' },
        { platform: 'Facebook', url: 'https://www.facebook.com/profile.php?id=100056900434020', icon: '/images/f2.webp' },
        { platform: 'YouTube', url: 'https://www.youtube.com/channel/UCxq5hrk1N1pZ8_Xmkv4xKLg', icon: '/images/y3.webp' },
        { platform: 'RuTube', url: 'https://rutube.ru/channel/39271788/', icon: '/images/r4.webp' },
      ],
    },
    {
      id: '0014',
      date: '23 Февраля, 2025',
      content: (
        <p>
          <span className="zolt">
            Так, ну что...
            <br />
            Нужно следовать за Звездой.
            <br />
            Скоро - обновление раздела KinoTheater.
          </span>
        </p>
      ),
      video: {
        videoId: '1058204133',
        videoHash: '131bf8b157',
        facadeImage: '/images/news/N14.avif',
        videoTitle: 'СНЕГ / Сергей Мавроди',
      },
    },
    {
      id: '0013',
      date: '19 Февраля, 2025',
      content: (
        <>
          <p>Всё очень просто. Мёртвые почуяли живого.</p>
          <Link to="/schriftstellerei/woche" className="yellow-underline" style={{ fontSize: '33px' }}>
            Неделька
          </Link>
          <br />
          <br />
          <p>Любые вопросы в наш век всевозможных коммуникаций решить можно по телефону, и мое личное присутствие, таким образом, — сплошные понты.</p>
          <br />
          <hr />
          <span>
            Читайте подборку самых смешных и забавных стихотворений газеты в разделах{' '}
            <a href="https://sergey-mavrodi.com/schriftstellerei/woche/zeitung111" style={{ textUnderlineOffset: '5px', textDecorationColor: 'rgb(255, 205, 0)' }}>
              Журнал (Сатира и юмор)
            </a>{' '}
            и{' '}
            <a href="https://sergey-mavrodi.com/schriftstellerei/woche/zeitung333" style={{ textUnderlineOffset: '5px', textDecorationColor: 'rgb(255, 205, 0)' }}>
              Журнал (Переделка песен)
            </a>.
          </span>
        </>
      ),
    },
    {
      id: '0012',
      date: '11 Февраля, 2025',
      content: (
        <>
          <p>Существует только первое место. И − все остальные.</p>
          <img src="./images/news/1102.webp" style={{ width: '593px', height: 'auto' }} />
          <p>
            Заниматься литературным творчеством мне нравится. Поэтому я им и занимаюсь. Я, кстати, считаю (знаю!), что мой литературный дар уж не ниже по крайней мере моего финансового. Так что советую почитать. Настоятельно рекомендую! Не пожалеете! Много нового и неожиданного о себе узнаете.
          </p>
          <br />
          <hr />
          <div className="yellow-underline2" style={{ textAlign: 'center', marginBottom: '13px' }}>
            <a href="https://sergeymavrodi.narod.ru/" style={{ textDecorationColor: 'rgb(255, 205, 0)' }}>
              https://sergeymavrodi.narod.ru/
            </a>
          </div>
          <div className="yellow-underline2" style={{ display: 'flex', justifyContent: 'space-between' }}>
            <a href="https://proza.ru/avtor/mavrodi" style={{ textDecorationColor: 'rgb(255, 205, 0)' }}>
              https://proza.ru/avtor/mavrodi
            </a>
            <a href="https://stihi.ru/avtor/sergeymavrodi" style={{ textDecorationColor: 'rgb(255, 205, 0)' }}>
              https://stihi.ru/avtor/sergeymavrodi
            </a>
          </div>
        </>
      ),
    },
    {
      id: '0011',
      date: '30 Января, 2025',
      content: (
        <>
          <p>Колебаться надо лишь при выборе цели. Далее надо просто действовать.</p>
          <Link to="/schriftstellerei/lieder" className="yellow-underline" style={{ fontSize: '33px' }}>
            Песни
          </Link>
          <br />
          <br />
          <p>Я ничего не читаю, не слушаю и не смотрю. А также, по возможности, ни с кем не общаюсь. Меня вполне устраивает собственное общество. И терпеть не могу события! Это они меня просто обожают.</p>
          <br />
          <hr />
          <Link to="/schriftstellerei/lieder/lied4" className="yellow-underline2">
            Цикл песен "Ромео и Джульетта"
          </Link>
        </>
      ),
    },
    {
      id: '0010',
      date: '27 Января, 2025',
      content: (
        <>
          <p>Всегда стоишь перед выбором: остановиться или идти дальше? И всегда идёшь дальше, хотя следовало бы остановиться. Но остановиться − невозможно.</p>
          <Link to="/schriftstellerei/drehbuch" className="yellow-underline" style={{ fontSize: '33px' }}>
            Киносценарии
          </Link>
          <br />
          <br />
          <p>
            Изумрудная оса. Знаете, в тропиках живёт? Жалит таракана в мозг, в результате чего тот теряет способность принимать самостоятельные решения. После чего берёт его за усы (за рога!) и ведёт к себе в нору (в стойло!). Где откладывает в него яйца. Вылупившиеся личинки пожирают бедного таракана заживо. Вот так же и женщина. Жалит постоянно. На ментальном уровне. Это у неё инстинктивно. Самой природой заложено. Самка! Сопротивляться невозможно. Физиология. Поэтому нельзя встречаться слишком часто. С одной и той же. Яда слишком много в крови накапливается. Впрочем, рано или поздно всё равно ошибаешься. Природу не обманешь.
          </p>
          <br />
          <hr />
          <p>
            У меня не бывает свободного времени. В обычном понимании этого слова. Мне его всегда катастрофически не хватает. Сколько еще не написано, не сделано!.. Скажем, та же литература. Обычная проблема большинства авторов — отсутствие сюжетов. У меня же проблема прямо противоположная — их избыток! Они переполняют меня! Я не успеваю их записывать! А есть еще ведь и стихи, и сценарии к фильмам. Да и финансовый апокалипсис, мать его! Надо все же доделать. Раз обещал. Время, время!
          </p>
        </>
      ),
    },
    {
      id: '0009',
      date: '24 Января, 2025',
      content: (
        <>
          <p>Свобода − это как возможность дышать.</p>
          <Link to="/schriftstellerei/gefangnis" className="yellow-underline" style={{ fontSize: '33px' }}>
            Тюрьма
          </Link>
          <br />
          <br />
          <p>
            Тюрьма это как свалка. Всё гниёт. Не гниют в этом мире, как известно, только благородные металлы. Золото, платина, серебро. Вот если у вас есть в душе что-то из золота, платины или серебра, это останется. Остальное же… Увы! Ну, если вы, конечно, весь из одних только благородных металлов состоите, то вам никакая тюрьма не страшна. Остальным же − не рекомендуется. Гниль − останется.
          </p>
          <br />
          <hr />
          <Link to="/schriftstellerei/gefangnis/zweiundvierzig" className="yellow-underline42" style={{ textDecorationColor: 'rgb(255, 205, 0)' }}>
            42
          </Link>
        </>
      ),
    },
    {
      id: '0008',
      date: '20 Января, 2025',
      content: (
        <>
          <p>Я не гений. Я — единственный!</p>
          <Link to="/schriftstellerei/tagebucher" className="yellow-underline" style={{ fontSize: '33px' }}>
            Дневники Сына Люцифера
          </Link>
          <br />
          <br />
          <p>
            У меня присутствует совершенно ясное и чёткое внутреннее… убеждение?.. ощущение?.. что никто, никто! в целом свете не может меня ни искушать, ни соблазнять, ни вообще как-то на меня влиять и воздействовать. НИКТО! Ни Бог, ни Дьявол. Я сам делаю всегда свой выбор. Я и только я!
          </p>
          <br />
          <hr />
          <p>Люцифер (Lucifer – «несущий свет», «утренняя звезда», «денница» лат.)</p>
        </>
      ),
    },
    {
      id: '0007',
      date: '17 Января, 2025',
      content: (
        <div style={{ textAlign: 'center' }}>
          <Link to="/schriftstellerei/gedichte" className="yellow-underline" style={{ fontSize: '33px' }}>Мои стихи</Link>
          <br />
          <br />
          <p style={{ textAlign: 'center' }}>
            Все пишут спокойно, а я – задыхаясь!
            <br />
            От гнева и боли
            <br />
            На стоны срываясь.
            <br />
            А я – поневоле!
            <br />
            Тоскуя и маясь.
            <br />
            От страха и боли
            <br />
            Боясь задохнуться.
            <br />
            Заснуть – не проснуться.
            <br />
            Уйти – не вернуться.
            <br />
            И не обернуться.
          </p>
        </div>
      ),
    },
    {
      id: '0006',
      date: '13 Января, 2025',
      content: (
        <>
          <p>
            Более великой книги, чем «Сын Люцифера» − не существует. <br />
            Если люди пока этого не понимают − тем хуже для них.
          </p>
          <Link to="/schriftstellerei/sohnluzifers" className="yellow-underline" style={{ fontSize: '33px' }}>
            Сын Люцифера
          </Link>
          <br />
          <br />
          <p>
            Это роман. Состоит он из отдельных, независимых новелл–дней, в которых Люцифер показывает Своему Сыну на конкретных жизненных примерах все человеческие пороки. Ставя обычных, простых людей в необычные и непростые отнюдь ситуации, когда им приходится делать выбор. Искушая их! И искушений этих люди большей частью, увы, не выдерживают...
          </p>
          <br />
          <hr />
          <p>
            Роман опубликован целиком, без купюр и именно в авторской редакции.
            <br />
            Надеюсь, вам понравится. Да уверен просто! Приятного чтения. :–))
          </p>
        </>
      ),
    },
    {
      id: '0005',
      date: '01 Января, 2025',
      content: (
        <p>
          <span className="zolt">
            Так, ну что...
            <br />
            Нужно следовать за Звездой.
            <br />
            Скоро - обновление раздела Творчество.
          </span>
        </p>
      ),
    },
    {
      id: '0004',
      date: '25 Декабря, 2024',
      content: (
        <>
          <Link to="/news/news4" className="yellow-underline" style={{ fontSize: '33px' }}>
            Идея создания Театра Сергея Мавроди
          </Link>
          <br />
          <br />
        </>
      ),
    },
    {
      id: '0003',
      date: '19 Декабря, 2024',
      content: (
        <p>
          <span className="zolt">
            "Слухи о моей смерти сильно преувеличены."
            <br />
            <br />
            Цитата.
          </span>
        </p>
      ),
    },
    {
      id: '0002',
      date: '05 Августа, 2024',
      content: (
        <p>
          <span className="zolt">
            Зеркала сайта Сергея Мавроди:
            <br />
            <br />
            <a href="https://www.mavrodi-mmm-2011.com/" target="_blank" rel="noopener noreferrer">
              www.mavrodi-mmm-2011.com
            </a>
            <br />
            <br />
            <a href="https://www.sergey-mavrodi.ms/" target="_blank" rel="noopener noreferrer">
              www.sergey-mavrodi.ms
            </a>
          </span>
        </p>
      ),
    },
    {
      id: '0001',
      date: '29 Июля, 2024',
      content: (
        <p>
          <span className="zolt">
            Официальный сайт Сергея Мавроди -
            <br />
            функционирует Правильно!
          </span>
        </p>
      ),
    },


    
  ];

  const totalItems = newsItems.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentNews = newsItems.slice(startIndex, endIndex);

  const handlePageChange = (page: number) => {
    setSearchParams({ page: page.toString() });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };



  return (
    <>
      <Helmet>
      <title>Новости Сергея Мавроди - Официальный сайт</title>
      <meta
        name="description"
        content="Последние новости о Сергее Мавроди, Творчестве, МММ и KinoTheater LUZIFER."
      />
      <meta name="keywords" content="Сергей Мавроди, МММ, Творчество, Новости, KinoTheater" />
      <meta name="author" content="Сергей Мавроди" />
      <meta property="og:title" content="Новости Сергея Мавроди" />
      <meta
        property="og:description"
        content="Последние новости о Сергее Мавроди и МММ."
      />
      <meta property="og:image" content="https://sergey-mavrodi.com/images/news/042.webp" />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:url" content="https://sergey-mavrodi.com/news" />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="ru_RU" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Новости Сергея Мавроди" />
      <meta name="twitter:description" content="Последние новости о Сергее Мавроди и МММ." />
      <meta name="twitter:image" content="https://sergey-mavrodi.com/images/news/042.webp" />
      <link rel="canonical" href="https://sergey-mavrodi.com/news" />
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'CollectionPage',
          'name': 'Новости Сергея Мавроди',
          'description': 'Последние новости о Сергее Мавроди, Творчестве, МММ и KinoTheater LUZIFER.',
          'url': 'https://sergey-mavrodi.com/news',
          'breadcrumb': {
            '@type': 'BreadcrumbList',
            'itemListElement': [
              {
                '@type': 'ListItem',
                'position': 1,
                'name': 'Главная',
                'item': 'https://sergey-mavrodi.com/',
              },
              {
                '@type': 'ListItem',
                'position': 2,
                'name': 'Новости',
                'item': 'https://sergey-mavrodi.com/news',
              },
            ],
          },
        })}
      </script>
    </Helmet>
      <div>
        <div className="breadcrumbs">
          <div id="breadcrumb">
            <Link to="/">Главная страница</Link> → Новости
          </div>
        </div>
        <div className="content">
          <h2>НОВОСТИ</h2>
          <br />
          <hr />
          <br />
          {currentNews.map((news) => (
            <div className="news_block" key={news.id}>
              <div className="news_block_head">
                <div className="news_date">
                  <i></i>
                  <span>{news.date}</span>
                </div>
              </div>
              <div className="content_white_cloud">
                <div className="cwc_top"></div>
                <div className="cwc_mid">
                  <div className="news_item">
                    <div className="news_item_one">
                      <div className="liked liked-scope-true" data-liked-type="news" data-liked-id={news.id}></div>
                      <div className="anons">
                        <div>
                          <strong>{news.content}</strong>
                          {news.video && (
                            <div style={{ position: 'relative', paddingTop: '56.25%', width: '100%' }}>
                              {!isVideoLoaded[news.id] ? (
                                <div
                                  className="video-facade"
                                  onClick={() => handleFacadeClick(news.id)}
                                  role="button"
                                  tabIndex={0}
                                  onKeyDown={(e) => e.key === 'Enter' && handleFacadeClick(news.id)}
                                >
                                  <img
                                    src={news.video.facadeImage}
                                    alt={`Превью видео: ${news.video.videoTitle}`}
                                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                    loading="lazy"
                                  />
                                  <svg
                                    className="play-button"
                                    viewBox="0 0 24 24"
                                    fill="rgb(255, 131, 0)"
                                    role="button"
                                    aria-label={`Воспроизвести видео: ${news.video.videoTitle}`}
                                  >
                                    <path d="M8 5v14l11-7z" />
                                  </svg>
                                </div>
                              ) : (
                                <iframe
                                  src={`https://player.vimeo.com/video/${news.video.videoId}?h=${news.video.videoHash}&badge=0&autopause=0&player_id=0&app_id=58479&autoplay=1`}
                                  allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
                                  style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 'none' }}
                                  title={news.video.videoTitle}
                                  sandbox="allow-same-origin allow-scripts allow-presentation"
                                />
                              )}
                            </div>
                          )}
                          <br />{news.videoContent && (
  <p style={{ textAlign: ['0023', '0025','0038','0040'].includes(news.id) ? 'center' : 'left' }}>
    <strong>{news.videoContent}</strong>
  </p>
)}
                          {news.socialLinks && (
                            <>
                              <hr />
                              <div className="social-links">
                                {news.socialLinks.map((link) => (
                                  <a
                                    key={link.platform}
                                    href={link.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    title={`Перейти на ${link.platform}`}
                                  >
                                    <img src={link.icon} alt={link.platform} width="30" height="30" style={{ marginLeft: '20px' }} />
                                  </a>
                                ))}
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="cwc_bot"></div>
              </div>
            </div>
          ))}
          {totalPages > 1 && (
            <div className="paginator">
              <ul>
                <li>
                  <button
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                    aria-label="Предыдущая страница"
                  >
                    {'<<<'}
                  </button>
                </li>
                {Array.from({ length: totalPages }, (_, index) => index + 1).map((page) => (
                  <li key={page} className={currentPage === page ? 'active' : ''}>
                    <button onClick={() => handlePageChange(page)} aria-label={`Страница ${page}`}>
                      {page}
                    </button>
                  </li>
                ))}
                <li>
                  <button
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                    aria-label="Следующая страница"
                  >
                    {'>>>'}
                  </button>
                </li>
              </ul>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default News;